import { ChargingSessionSearchResponseDto } from '../api/dto/charging-sessions.dto'
import { ApiResult } from 'src/Libs/api'
import { AuthFetchWithResponse } from 'src/Types/api'
import { AuthFetchError } from '@e3dc-react/shell/Types'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { handleFetchError } from 'src/Libs/api/utils'

const MAX_PAGE_SIZE = 100
const PAGE = 0

/**
 * API function for fetching charging sessions total elements of a single installation.
 * @param installationId - number | undefined
 * @param authFetch - AuthFetchWithResponse
 */
export const fetchChargingSessionsTotalElements = async (
  installationId: number | undefined,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<ChargingSessionSearchResponseDto, AuthFetchError | Error>> => {
  try {
    const response = await authFetch<ChargingSessionSearchResponseDto>({
      path: `sessions/installation/${installationId}?page=${PAGE}&size=${MAX_PAGE_SIZE}`,
      endpoint: process.env.REACT_APP_HAGER_BRIDGE_SERVICE,
      method: 'GET',
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<ChargingSessionSearchResponseDto, AuthFetchError | Error>(response.data, false)
    }

    return new ApiResult<ChargingSessionSearchResponseDto, AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<ChargingSessionSearchResponseDto>(error)
  }
}
